import React, { type JSX } from "react";
import { MdHelpOutline, MdOutlineInfo } from "react-icons/md";

import { Popover } from "../Popover";

interface Props {
  ariaLabel?: string;
  children: React.ReactNode;
  popoverClassName?: string;
  portal?: boolean;
  type?: "help" | "info";
  position?: "bottom";
}

export const Tooltip = ({
  ariaLabel,
  children,
  popoverClassName,
  portal,
  type = "help",
  position,
}: Props): JSX.Element => {
  return (
    <Popover
      ariaLabel={ariaLabel}
      className="*:flex *:items-center"
      label={
        <div>
          {type === "help" ? (
            <MdHelpOutline size="1.5rem" className="text-brand-primary opacity-70" />
          ) : (
            <MdOutlineInfo size="1.5rem" className="text-brand-primary opacity-70" />
          )}
        </div>
      }
      popoverClassName={popoverClassName}
      portal={portal}
      position={position}
    >
      {children}
    </Popover>
  );
};
